import React from "react";
import Typical from "react-typical";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
                <a href='https://linkedin.com/in/miguelv-dev/'>
                    <i className='fa fa-linkedin-square'></i>
                </a>
                <a href='https://github.com/miguel4prez'>
                    <i className='fa fa-github'></i>
                </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'm <span className='highlighted-text'>Miguel</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Full-Stack Developer",
                    3000,
                    "Creative Problem Solver",
                    3000,
                    "Agile Team Collaborator",
                    3000,
                    "Team Player",
                    3000,
                    "Passionate",
                    3000,
                    "Fast Learner",
                    3000,
                ]
                  }
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
            Specialize in crafting interactive and mobile-friendly user interfaces with 
            <span className='font-end-word'> Full-Stack</span> operations.
            </span>
          </div>

          <div className="profile-options">
            {/* <button className="btn primary-btn"
            onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            > Hire Me </button> */}
            <a href="Miguel_Vasquez_SE_Resume.pdf" download="Miguel_Vasquez_Resume">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
